import numeral from 'numeral';

numeral.zeroFormat('$0');
numeral.nullFormat('--');

/**
 * A function to format monetary values
 * @param {number} value - The sum of money to format
 * @returns {string} - The formatted value
 */
export default function getFormattedTotal(value) {
  return numeral(value).format('$0,0');
}
